import type { ChangelogData } from "./changelogTypes";

export const changelog: ChangelogData = {
  versions: [
    {
      version: "v48.0.0",
      date: "2026-09-18",
      entries: [
        {
          id: "e9aa259",
          category: "feature",
          title: "Swivu Updates",
          description:
            "Open Updates from the bell in the header or on My Swivu to see alerts and in-progress work in one place. Start from a summary of what needs attention, browse notable items or the full list with search and filters, mark everything read, and ask Sol about what’s going on. Top-of-page alert banners are gone—new activity lives in Updates instead.",
        },
      ],
    },
    {
      version: "v49.0.0",
      date: "2026-10-09",
      entries: [
        {
          id: "23df2d16",
          category: "improvement",
          title: "Catch up or look back",
          description:
            "In Updates, catch up on what you have not seen, or look back over today, yesterday, the last 7 days, or the last 30 days, instead of popup alerts.",
        },
        {
          id: "ed15bc04",
          category: "feature",
          title: "Connections",
          description:
            "Ownership is now Connections, where you see who is assigned, choose who gets notified, and pick reminder recipients.",
        },
        {
          id: "6e94d9d1",
          category: "feature",
          title: "Workforce app version",
          description:
            "The users list and a person’s Overview show which Workforce app version is installed on their devices.",
        },
        {
          id: "94f55110",
          category: "fix",
          title: "Edits made while saving are kept",
          description:
            "If you change a new schedule item while it is still saving, that change stays and is saved instead of being dropped.",
        },
        {
          id: "15c06f88",
          category: "feature",
          title: "Drag files to upload",
          description:
            "Drag photos and documents onto a task in the schedule, or onto Media and Documents, to upload them.",
        },
        {
          id: "d7b5871e",
          category: "fix",
          title: "Adjust Points permission",
          description:
            "Adjust Points stays hidden in File Detail unless you can manage incentives.",
        },
        {
          id: "60500db2",
          category: "improvement",
          title: "Save As in Manage View",
          description:
            "Save and Save As are in Manage View, and a name that is already taken is flagged under the name field.",
        },
        {
          id: "e29c56ed",
          category: "improvement",
          title: "Clearer budget readout",
          description:
            "Extracted budget figures are easier to read, with amounts and percentages formatted and blank fields left out.",
        },
        {
          id: "0ab62d8e",
          category: "feature",
          title: "Task from a lead",
          description:
            "Turn a site lead into a task after reviewing what will be created, then open that task from the lead.",
        },
      ],
    },
    {
      version: "v50.0.0",
      date: "2026-10-15",
      entries: [
        {
          id: "d78711d3",
          category: "feature",
          title: "Swivu MCP",
          description:
            "Under Integrations, connect AI tools like ChatGPT or Claude to your board, share a workflow guide others can download, and finish connecting even if you had to log into Swivu first.",
        },
        {
          id: "4587c0d8",
          category: "feature",
          title: "Manage AI and CompanyCam keys safely",
          description:
            "Owners and admins can add, replace, or disconnect the CompanyCam and OpenAI keys in Settings. Saved keys are never shown again.",
        },
        {
          id: "16a883f2",
          category: "improvement",
          title: "What's new in the header",
          description:
            "When there are updates you have not read, What's new appears beside the bell in the header. It hides again once you have read them.",
        },
        {
          id: "fb7a9796",
          category: "fix",
          title: "Reordering new settings rows",
          description:
            "Dragging a newly added row in a settings list before it finishes saving no longer crashes the list.",
        },
        {
          id: "2b0df085",
          category: "fix",
          title: "Editing reminders on the timeline",
          description:
            "Opening a reminder from the timeline no longer freezes the editor.",
        },
      ],
    },
    {
      version: "v50.0.1",
      date: "2026-10-20",
      entries: [
        {
          id: "f6b80443",
          category: "fix",
          title: "Budget Editor Oops with unnamed tasks",
          description:
            "Opening Budget Editor from search or after adding a budget no longer crashes with an Oops when another task on the board has no name.",
        },
      ],
    },
    {
      version: "v50.1.0",
      date: "2026-10-23",
      entries: [
        {
          id: "e8cf580d",
          category: "fix",
          title: "Media alerts and viewer stay on top",
          description:
            "When Media is open, delete and CompanyCam link messages, and the expanded photo, show in front of the Media window instead of behind it.",
        },
        {
          id: "fea7878e",
          category: "feature",
          title: "Media manage by day",
          description:
            "In Media, photos are grouped by day with clearer headers, you can select several at once, and Resource and Client Media match Task. The toolbar is tighter so photos lead.",
        },
        {
          id: "fcc871f5",
          category: "fix",
          title: "Correct account after logout",
          description:
            "After you log out and sign in as someone else, session tracking uses the new account instead of the previous one.",
        },
        {
          id: "56eea00c",
          category: "fix",
          title: "Small screen opens Workforce",
          description:
            "On a narrow screen, HQ sends you to Workforce instead of staying on HQ.",
        },
      ],
    },
    {
      version: "v50.2.0",
      date: "2026-10-23",
      entries: [
        {
          id: "746da5bc",
          category: "improvement",
          title: "Faster Media bulk delete",
          description:
            "When you delete several photos in Media, they clear at the same time and each tile shows it is deleting, so the gallery updates without a pile of toasts.",
        },
        {
          id: "7cee581a",
          category: "fix",
          title: "Media and Documents column icons",
          description:
            "After you add or remove photos or documents, the Media and Documents icons on the grids update to match.",
        },
      ],
    },
    {
      version: "v52.0.0",
      date: "2026-10-30",
      entries: [
        {
          id: "86ff89db",
          category: "feature",
          title: "Board Checklists",
          description:
            "A new Checklists view under Tracking shows what still needs to be done, and for whom, across people, tasks, and clients. Checklists are grouped into Needs attention, In progress, and Settled. Open one to see its grid for any day, tick off checks, add comments and evidence photos, nudge someone, or review several checks side by side.",
        },
        {
          id: "dc3f99f0",
          category: "improvement",
          title: "Assignees can comment and add images",
          description:
            "If you are assigned to a checklist, you can add or clear comments and add or remove images on its items. A checklist created from a task, resource, or client dashboard uses the Can View and Can Edit roles saved in Settings.",
        },
        {
          id: "cb212fcf",
          category: "feature",
          title: "Budget Status column",
          description:
            "Estimates and Actuals show a read-only Status column taken from the linked tasks.",
        },
        {
          id: "7dd8312c",
          category: "improvement",
          title: "Smoother Media and Documents scrolling",
          description:
            "Media Manage and the Media and Documents tiles load more as you scroll, day headers stay in view in Manage, and opening Manage no longer reloads the list.",
        },
        {
          id: "dc1a2acc",
          category: "improvement",
          title: "Notes in Updates",
          description:
            "Updates about added notes now appear under Notes instead of Nudges.",
        },
        {
          id: "08779585",
          category: "improvement",
          title: "Import & export in Updates",
          description:
            "The Import section in Updates is now Import & export, and each job is labeled Import or Export so they are not confused.",
        },
      ],
    },
  ],
};
